import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomNav } from "@/components/navigation/BottomNav";
import { CommonHeader } from "./CommonHeader";
import { OfflineBanner } from "@/components/OfflineBanner";
import { usePokerStore } from "@/features/poker/poker-store";
import { useTranslation } from "react-i18next";
import { Play } from "lucide-react";

interface MobileLayoutProps {
  children: ReactNode;
}

export const MobileLayout = ({ children }: MobileLayoutProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const location = useLocation();
  const pokerRoom = usePokerStore((s) => s.room);
  const pokerToken = usePokerStore((s) => s.token);
  const hasActiveSession = pokerRoom && pokerToken;
  const isAtTable = location.pathname === "/table";

  const isLessonPage = location.pathname.startsWith("/learn/");
  const noHeaderPaths = ["/", "/profile", "/welcome", "/table", "/login", "/register", "/privacy", "/terms", "/cookies"];
  const noFooterPaths = ["/", "/table", "/welcome", "/login", "/register", "/privacy", "/terms", "/cookies"];

  const showHeader = !noHeaderPaths.includes(location.pathname) && !isLessonPage;
  const showFooter = !noFooterPaths.includes(location.pathname) && !isLessonPage;

  return (
    <div className="min-h-screen bg-background">
      <OfflineBanner />
      {showHeader && <CommonHeader />}
      {/* Floating banner: return to active table */}
      {hasActiveSession && !isAtTable && showFooter && (
        <button
          onClick={() => navigate("/table")}
          className="fixed top-0 left-0 right-0 z-[60] flex items-center justify-center gap-2 bg-secondary py-2 text-sm font-semibold text-secondary-foreground shadow-md"
        >
          <Play className="h-4 w-4" />
          {t("return_to_table")}
        </button>
      )}
      <main id="main-content">
        {children}
      </main>
      {showFooter && <BottomNav />}
    </div>
  );
};
